import { Observable } from '../Observable';
import { createOperatorSubscriber } from './OperatorSubscriber';
import { noop } from '../util/noop';
import { from } from '../observable/from';
export function distinct(keySelector, flushes) {
    return function (source) {
        return new Observable(function (subscriber) {
            var distinctKeys = new Set();
            source.subscribe(createOperatorSubscriber(subscriber, function (value) {
                var key = keySelector ? keySelector(value) : value;
                if (!distinctKeys.has(key)) {
                    distinctKeys.add(key);
                    subscriber.next(value);
                }
            }));
            flushes && from(flushes).subscribe(createOperatorSubscriber(subscriber, function () { return distinctKeys.clear(); }, noop));
        });
    };
}
//# sourceMappingURL=distinct.js.map